import _ from "lodash"

export type TObserverCallback<T> = (arg:T) => void

export default class Observer<T> {
    private _cb : TObserverCallback<T>[] = []
    private _arg! : T

    get subscribers() { return this._cb }
    get value(){ return this._arg }

    subscribe(cb:TObserverCallback<T>){
        this._cb.push(cb)
        return this
    }
    unsubscribe(cb:TObserverCallback<T>){
        _.pull(this._cb, cb)
        return this
    }
    next(arg:T) {
        this._arg = arg
    }
    clear(){
        this._cb.length = 0
        return this
    }
    callback(){
        for(const cb of this._cb) cb(this._arg)
    }
}